module.exports = __webpack_public_path__ + "static/sport/left.185b6a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottery/left.png
// module id = yas3
// module chunks = 0